import { useState, useEffect, useCallback } from 'react';
import { getRiskMapData } from '../services/riskClassificationAssignmentService';

/**
 * Risk map data for Phase 3 view/export. Returns rows with resolved effective criticality per entity.
 * @param {string} organizationId
 * @param {object} structure - { departments, rooms, beds, equipment, floors, buildings, locations }
 */
export function useRiskMapData(organizationId, structure) {
  const [rows, setRows] = useState([]);
  const [totalEntities, setTotalEntities] = useState(0);
  const [configuredCount, setConfiguredCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!organizationId) {
      setRows([]);
      setTotalEntities(0);
      setConfiguredCount(0);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const result = await getRiskMapData(organizationId, structure || {});
      setRows(result.rows);
      setTotalEntities(result.totalEntities);
      setConfiguredCount(result.configuredCount);
    } catch (err) {
      console.error('[useRiskMapData]', err);
      setError(err.message || 'Failed to load risk map');
      setRows([]);
      setTotalEntities(0);
      setConfiguredCount(0);
    } finally {
      setLoading(false);
    }
  }, [organizationId, structure]);

  useEffect(() => {
    load();
  }, [load]);

  return { rows, totalEntities, configuredCount, loading, error, refetch: load };
}
